import React from "react";
import { useSiteContent } from "../content/SiteContentContext.jsx";
import { resolveImage } from "../utils/resolveImage";
import { RichText } from "../utils/richText.jsx";
import Awrapper from "./Awrapper.jsx";
import img from "../assets/images/main/about.webp";

// Sección "Ventajas" de la portada, integrada al sistema de diseño de marca (fondo suave,
// blob-glow, icon-orb, aparición escalonada). El encabezado y cada ventaja (ícono/título/
// descripción) vienen del contenido (CMS); subtítulo y descripciones son opcionales.
const AboutCard = () => {
  const { homeAbout, homeAboutHeading } = useSiteContent();
  const heading = homeAboutHeading || {};
  const items = Array.isArray(homeAbout) ? homeAbout : [];

  return (
    <>
      <section className="brand-soft relative overflow-hidden">
        <div className="mx-auto w-full max-w-[1180px] px-6 py-16 md:py-20">
          <div className="flex flex-col md:flex-row items-center gap-12 md:gap-14">
            <div className="w-full md:w-2/5 relative flex justify-center fade-up">
              <div className="blob-glow w-[340px] h-[340px] top-1/2 left-1/2 -translate-x-1/2 -translate-y-1/2" />
              <img
                src={img}
                alt=""
                className="relative z-[1] w-full max-w-[380px] rounded-[28px] shadow-2xl object-cover aspect-[4/5]"
              />
            </div>

            <div className="w-full md:w-3/5">
              {heading.subtitle ? (
                <span className="eyebrow fade-up">{heading.subtitle}</span>
              ) : null}
              <h2 className="mt-3 font-bold text-tPrimary text-[28px] ss:text-[38px] leading-[1.12] fade-up">
                {heading.title || "Ventajas de estudiar con nosotros"}
              </h2>
              <div className="w-[84px] h-[5px] rounded bg-[#0165fc] mt-5 fade-up" />

              <div className="mt-9 flex flex-col gap-5">
                {items.map((val, index) => (
                  <div
                    key={index}
                    className="content-card flex items-start gap-5 fade-up"
                    style={{ animationDelay: `${index * 110}ms` }}
                  >
                    {val.cover ? (
                      <span className="icon-orb w-14 h-14 flex-shrink-0">
                        <img
                          src={resolveImage(val.cover)}
                          alt=""
                          className="w-7 h-7 object-contain"
                          style={{ filter: "brightness(0) invert(1)" }}
                        />
                      </span>
                    ) : null}
                    <div>
                      {val.title ? (
                        <h3 className="font-bold text-tPrimary text-[18px] mb-1.5">{val.title}</h3>
                      ) : null}
                      <RichText html={val.desc} className="text-tPrimary leading-[26px]" />
                    </div>
                  </div>
                ))}
              </div>
            </div>
          </div>
        </div>
      </section>

      <Awrapper />
    </>
  );
};

export default AboutCard;
